import { FC, useEffect, useState } from 'react';
import cs from 'classnames';
import { useAtomValue } from 'jotai';
import { Input as BaseInput } from './base-input';
import { useTranslation } from 'react-i18next';
import { useRouteLoader } from '~/utils/use-route-loader';
import { $SearchSugData } from 'shared/atoms/search-sug';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import XmarkCircleFill from '@lemon8/design/lib/icons/icon_assets/xmark_circle_fill.svg';
import Magnifyingglass from '@lemon8/design/lib/icons/icon_assets/magnifyingglass.svg';
import { debounce } from 'lodash';

import './style.scss';

interface Props {
  className?: string;
  onQueryChange?: (query: string) => void;
}

export const SearchInput: FC<Props> = ({ className, onQueryChange }) => {
  const { isMobile } = useAtomValue($UserAgent);
  const { t } = useTranslation();

  const [query, setQuery] = useState('');
  const [isSearching, setSearching] = useState(false);

  const handleFocus = () => {
    setSearching(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setQuery(value);
  };

  const handleClear = () => {
    handleFocus();
    setQuery('');
  };

  const handleCancel = () => {
    setSearching(false);
    setQuery('');
  };

  const loader = useRouteLoader(
    'search-sug-request',
    {
      keyword: query,
    },
    {
      atoms: {
        $SearchSugData,
      },
    },
  );

  const loadData = debounce(() => {
    loader.load();
  }, 0); // 和旧代码保持一致，看情况调整

  useEffect(() => {
    if (query !== '') {
      loadData();
    }

    onQueryChange?.(query);
  }, [query]);

  return (
    <form
      className={cs('wap-search-input', className, 'fixed-top', {
        isPC: !isMobile,
      })}
      action=""
      onSubmit={(e: React.FormEvent) => {
        e.preventDefault();
      }}
    >
      {/* iOS键盘显示回车为搜索需要使用form包裹 */}
      <BaseInput
        type="search"
        value={query}
        onFocus={handleFocus}
        onChange={handleChange}
        beforeIcon={<Magnifyingglass className="wap-search-icon search" />}
        afterIcon={
          <XmarkCircleFill
            className={cs('wap-search-icon', 'clear', {
              show: query,
            })}
          />
        }
        allowClear={true}
        onClear={handleClear}
        placeholder={t('search')}
      />
      <span
        className={cs('wap-search-cancel', {
          hidden: !isSearching,
        })}
        onClick={handleCancel}
      >
        {t('cancel')}
      </span>
    </form>
  );
};
